import ActionType from './ActionType';
import { MeshStatus } from '../generated/src/models';

export interface DataAction {
  type: ActionType.SET_MESH_FILES_IMPORTED;
  data: MeshStatus[];
}

export const initialMeshFilesImported: MeshStatus[] = [];

export const meshFilesImportedReducer = (state: MeshStatus[], action: DataAction) => {
  switch (action.type) {
    case ActionType.SET_MESH_FILES_IMPORTED:
      // console.log('setting SET_MESH_FILES_IMPORTED in meshFilesImportedReducer: ', action.data);
      return action.data;
    default:
      return state;
  }
};
